module.exports = __webpack_public_path__ + "static/media/sub1.79832da1.png";